import { render, staticRenderFns } from "./Appbox.vue?vue&type=template&id=891a69b6&"
import script from "./Appbox.vue?vue&type=script&lang=js&"
export * from "./Appbox.vue?vue&type=script&lang=js&"
import style0 from "./Appbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports